var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "brb-input flex-grow-1" },
    [
      _c(
        "brb-input-group",
        _vm._b(
          {
            attrs: {
              size: _vm.size,
              prepend: _vm.label,
              append: _vm.append,
              required: _vm.required,
            },
            scopedSlots: _vm._u(
              [
                !!_vm.$slots.prepend
                  ? {
                      key: "prepend",
                      fn: function () {
                        return [_vm._t("prepend")]
                      },
                      proxy: true,
                    }
                  : null,
                !!_vm.$slots.append
                  ? {
                      key: "append",
                      fn: function () {
                        return [_vm._t("append")]
                      },
                      proxy: true,
                    }
                  : null,
              ],
              null,
              true
            ),
          },
          "brb-input-group",
          _vm.$attrs,
          false
        ),
        [
          _vm.numeric || _vm.mobile || _vm.phone || _vm.nationalId
            ? _c(
                "numeric-input",
                _vm._g(
                  _vm._b(
                    {
                      ref: "brb-input",
                      attrs: {
                        disabled: _vm.disabled,
                        "input-class": _vm.computedInputClass,
                        "input-style": _vm.inputStyle,
                        separator: _vm.separateNumbers,
                        mobile: _vm.mobile,
                        phone: _vm.phone,
                        "national-id": _vm.nationalId,
                        "string-output": _vm.stringOutput,
                        tabindex: _vm.tabindex,
                      },
                      model: {
                        value: _vm.model,
                        callback: function ($$v) {
                          _vm.model = $$v
                        },
                        expression: "model",
                      },
                    },
                    "numeric-input",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                )
              )
            : _vm.textarea
            ? _c(
                "b-textarea",
                _vm._g(
                  _vm._b(
                    {
                      ref: "brb-input",
                      class: _vm.computedInputClass,
                      style: _vm.inputStyle,
                      attrs: {
                        id: _vm.id,
                        disabled: _vm.disabled,
                        tabindex: _vm.tabindex,
                      },
                      model: {
                        value: _vm.model,
                        callback: function ($$v) {
                          _vm.model = $$v
                        },
                        expression: "model",
                      },
                    },
                    "b-textarea",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                )
              )
            : _vm.date
            ? _c(
                "date-picker",
                _vm._b(
                  {
                    class: _vm.computedInputClass,
                    attrs: {
                      id: _vm.id,
                      disabled: _vm.disabled,
                      type: _vm.type,
                      size: _vm.size,
                      tabindex: _vm.tabindex,
                    },
                    model: {
                      value: _vm.model,
                      callback: function ($$v) {
                        _vm.model = $$v
                      },
                      expression: "model",
                    },
                  },
                  "date-picker",
                  _vm.$attrs,
                  false
                )
              )
            : _vm.time
            ? _c(
                "time-input",
                _vm._b(
                  {
                    attrs: {
                      id: _vm.id,
                      "input-class": _vm.computedInputClass,
                      disabled: _vm.disabled,
                      tabindex: _vm.tabindex,
                    },
                    model: {
                      value: _vm.model,
                      callback: function ($$v) {
                        _vm.model = $$v
                      },
                      expression: "model",
                    },
                  },
                  "time-input",
                  _vm.$attrs,
                  false
                )
              )
            : _c(
                "b-input",
                _vm._g(
                  _vm._b(
                    {
                      ref: "brb-input",
                      class: _vm.computedInputClass,
                      style: _vm.inputStyle,
                      attrs: {
                        id: _vm.id,
                        autocomplete: _vm.autocomplete,
                        disabled: _vm.disabled,
                        type: _vm.type,
                        tabindex: _vm.tabindex,
                        dir: _vm.dir,
                      },
                      model: {
                        value: _vm.model,
                        callback: function ($$v) {
                          _vm.model = $$v
                        },
                        expression: "model",
                      },
                    },
                    "b-input",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                )
              ),
        ],
        1
      ),
      !_vm.noError && _vm.error && typeof _vm.error === "string"
        ? _c(
            "span",
            { staticClass: "d-block text-right text-danger small mt-2" },
            [_vm._v(" " + _vm._s(_vm.error) + " ")]
          )
        : _vm._e(),
      _vm.currency && _vm.model
        ? _c("span", { staticClass: "d-block text-right small mt-2" }, [
            _vm._v(" " + _vm._s(_vm.changeRialToToman(_vm.model)) + " "),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }